import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      try {
        const hash = window.location.hash || '';
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) { navigate('/login'); return; }
        const session_id = decodeURIComponent(m[1]);
        const { data } = await api.post('/auth/session', { session_id });
        setUser(data.user);
        window.location.hash = '';
        navigate('/dashboard', { state: { user: data.user }, replace: true });
      } catch (e) {
        setError('Sign-in failed. Please try again.');
        setTimeout(() => navigate('/login'), 1800);
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-navy text-white" data-testid="auth-callback">
      <div className="h-10 w-10 rounded-full border-2 border-gold/40 border-t-gold animate-spin mb-4" />
      <div className="font-serif text-xl text-gold">Securing your session…</div>
      {error && <div className="mt-4 text-sm text-red-300">{error}</div>}
    </div>
  );
}
